//region 1. Platform Libraries
import bodyParser from 'body-parser';
import express from 'express';
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
//endregion

const context = {
    router: express.Router({ mergeParams: true }),
    serviceEvents: null,
    logger: null,
};

context.router.use('/', checkObjectID);
context.router.use('/', checkStreamIndex);
context.router.put('/', bodyParser.json());
context.router.put('/', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
    log('debug', JSON.stringify(req.body, null, 2));
    if (req.body.length === 0) {
        const message = 'No Request or Request Body';
        log('error', message);
        res.status(400).send(message);
        return;
    }
    [
        'recorderId',
        'module',
        'status',
    ].forEach((property) => {
        if ({}.hasOwnProperty.call(req.body, property)) {
            return;
        }
        const message = `Video Info Contains No ${property}`;
        log('error', message);
        res.status(400).send(message);
        throw new Error(message);
    });

    const serviceEvent = {
        camera_id: new MongoClient.ObjectId(req.params.id),
        stream_index: parseInt(req.params.index, 10),
        service_name: req.body.module,
        service_id: new MongoClient.ObjectId(req.body.recorderId),
        message: req.body.status,
        created: new Date(),
    };
    context.serviceEvents.insert(
        serviceEvent,
        (serviceEventsInsertErr) => {
            if (serviceEventsInsertErr) {
                log('error', serviceEventsInsertErr.message);
                res.status(500).send(serviceEventsInsertErr.message);
                return;
            }
            log('info', '200 OK');
            res.sendStatus(200);
        },
    );
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/status
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountStreamStatus(options) {
    context.logger = options.logger;
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountStreamStatus' });
    log('debug', 'Mounting router for /c/:/s/:/status....');
    options.app.use('/cameras/:id/streams/:index/status', context.router);
    context.serviceEvents = options.database.collection('service_events');
    log('info', 'Router for /c/:/s/:/status Mounted');
}
